const userDataFormNL = {
    "view": {
        "title": "Voltooi Uw Informatie",
        "stepZero": {
            "title": "Verklaring",
            "form": {
                "label": {
                    "declarationPoint1": "Door deze informatie te verstrekken, erkent en stemt u ermee in dat deze naar beste weten en kunnen wordt verstrekt. We streven ernaar om ervoor te zorgen dat alle informatie nauwkeurig en waarheidsgetrouw is.",
                    "declarationPoint2": "Houd er rekening mee dat het verstrekken van valse informatie of het verkeerd voorstellen van de waarheid aanzienlijke gevolgen kan hebben. We dringen er bij alle gebruikers op aan om de informatie die ze verstrekken te verifiëren en dit platform verantwoordelijk te gebruiken.",
                    "declarationPoint3": "De aansprakelijkheid voor eventuele verkeerde informatie of fouten ligt uitsluitend bij de persoon die de informatie verstrekt. Wij aanvaarden geen verantwoordelijkheid voor de gevolgen van onjuiste of misleidende informatie verstrekt door gebruikers.",
                    "declarationPoint4": "Door op <strong>'Volgende'</strong> te klikken, stemt u in met deze voorwaarden en bevestigt u dat u zich volledig bewust bent van de implicaties van het verstrekken van onjuiste of valse informatie.",
                    "declarationAgreement": "Ik ga volledig akkoord en begrijp de bovenstaande voorwaarden."
                },
                "button": {
                    "next": "Volgende"
                }
            }
        },
        "stepOne": {
            "title": "Persoonlijke Informatie",
            "form": {
                "label": {
                    "firstName": "Voornaam",
                    "lastName": "Achternaam",
                    "streetAndNumber": "Straat en Nummer",
                    "zipCode": "Postcode",
                    "city": "Stad",
                    "country": "Land"
                },
                "placeholder": {
                    "country": "Selecteer Land"
                },
                "help_text": {
                    "firstName": "Als u zich registreert als een LLC of andere zakelijke entiteit, wordt dit veld gebruikt voor de voornaam van de CEO.",
                    "lastName": "Als u zich registreert als een LLC of andere zakelijke entiteit, wordt dit veld gebruikt voor de achternaam van de CEO.",
                    "country": "Als u zich registreert als een LLC of andere zakelijke entiteit, wordt dit veld gebruikt voor het land van de CEO."
                },
                "button": {
                    "next": "Volgende"
                }
            }
        },
        "stepTwo": {
            "title": "Zakelijke Informatie",
            "form": {
                "label": {
                    "businessType": "Bedrijfstype",
                    "companyName": "Bedrijfsnaam",
                    "businessStreet": "Straat en Nummer",
                    "businessCity": "Stad",
                    "businessZip": "Postcode",
                    "businessCountry": "Land",
                    "ceoFirstName": "Wettelijke Vertegenwoordiger / CEO Voornaam",
                    "ceoLastName": "Wettelijke Vertegenwoordiger / CEO Achternaam",
                    "tradeRegistryExport": "Handelsregister Export",
                    "tradeRegistryCompanyUrl": "Handelsregister Bedrijfs-URL",
                    "vatNumber": "BTW-nummer",
                    "taxNumber": "Belastingnummer"
                },
                "option": {
                    "businessType": {
                        "soleProprietorship": "Eenmanszaak",
                        "limitedLiabilityCompany": "Besloten vennootschap",
                        "partnershipOrganized": "Vennootschap onder firma",
                        "publicLimitedCompanyByShares": "Naamloze vennootschap",
                        "other": "Anders"
                    }
                },
                "placeholder": {
                    "businessType": "Selecteer Bedrijfstype",
                    "businessCountry": "Selecteer Land"
                },
                "help_text": {
                    "companyName": "De bedrijfsnaam moet overeenkomen met wat oorspronkelijk in Stripe is ingediend. Wijzig alleen als het verschilt van wat oorspronkelijk is ingediend.",
                    "tradeRegistryExport": "Geef een officieel handelsregisterexport van uw bedrijf. Alleen PDF, max. bestandsgrootte 5 MB. Als u hulp nodig heeft bij het vinden van uw handelsregisterexport, neem dan contact op met het register in uw land. Een onofficiële lijst van de registers is te vinden <1>hier</1>.",
                    "tradeRegistryCompanyUrl": "Geef uw bedrijfs-URL op bij het handelsregister van uw land. Als uw register dit niet ondersteunt, voer dan alleen een register-URL in."
                },
                "button": {
                    "previous": "Vorige",
                    "next": "Volgende"
                }
            }
        },
        "stepThree": {
            "title": "Bevestiging",
            "form": {
                "label": {
                    "personalInformation": "Persoonlijke Informatie",
                    "personalName": "Naam",
                    "personalAddress": "Adres",
                    "businessInformation": "Zakelijke Informatie",
                    "companyName": "Bedrijf",
                    "ceoName": "CEO Naam",
                    "businessAddress": "Adres",
                    "businessType": "Bedrijfstype",
                    "taxNumber": "Belastingnummer",
                    "vatNumber": "BTW-nummer",
                    "tradeRegistryExportUploaded": "Handelsregister Export Geüpload",
                    "tradeRegistryCompanyUrl": "Handelsregister Bedrijfs-URL",
                    "notAvailable": "N/B"
                },
                "button": {
                    "previous": "Vorige",
                    "save": "Opslaan",
                    "next": "Volgende"
                }
            },
            "message": {
                "success": "Uw informatie is bijgewerkt!",
                "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
            },
            "modal": {
                "submitYourInformation": {
                    "header": "Dien Uw Informatie In",
                    "body": {
                        "point1": "Door op <strong>'Bevestigen'</strong> te klikken, bevestigt u dat alle informatie die u heeft verstrekt naar beste weten en kunnen nauwkeurig en waarheidsgetrouw is.",
                        "point2": "Bevestigt u dat alle verstrekte gegevens correct zijn en erkent u de mogelijke gevolgen van het indienen van onjuiste informatie?"
                    },
                    "button": {
                        "confirm": "Bevestigen",
                        "cancel": "Annuleren"
                    }
                }
            }
        },
        "stepFour": {
            "title": "Verifieer Mobiel Nummer",
            "form": {
                "label": {
                    "mobileNumber": "Voer Uw Mobiele Nummer In",
                    "deliveryMedium": "Bezorgmethode: ",
                    "deliveryMediumSMS": "SMS",
                    "deliveryMediumWhatsapp": "WhatsApp",
                    "otp": "OTP"
                },
                "help_text": {
                    "mobileNumber": "Opmerking: Mobiel nummer is vereist voor verificatie als standaardprocedure omdat het kan worden gebruikt voor inlogvalidatie. U moet de eigenaar van het nummer zijn en er toegang toe hebben voor een soepel verificatieproces.",
                    "isFormUSorCanada": "* Als u in de VS of Canada bent gevestigd, neem dan contact op met ons ondersteuningsteam nadat u uw mobiele nummer heeft ingevoerd.",
                    "deliveryMediumWhatsapp": "Opmerking: Zorg ervoor dat u een WhatsApp-account op dit nummer heeft om het bericht te ontvangen.",
                    "otp": "Voer de OTP in die naar uw mobiele nummer is verzonden."
                },
                "message": {
                    "errorMobileNumberEmpty": "Mobiel nummer is vereist.",
                    "errorMobileNumberInvalid": "Ongeldig mobiel nummer.",
                    "errorMobileNumberSame": "Dit nummer is al toegevoegd en geverifieerd met uw account.",
                    "errorOTPRequired": "OTP is vereist.",
                    "errorOtpSendLimitExhasuted": "U kunt geen OTP's meer aanvragen omdat u de <strong>MAX limiet ({{maxLimit}})</strong> voor OTP-verzoeken heeft bereikt. Neem contact op met de ondersteuning voor meer informatie!",
                    "errorMobileUpdateLimitExhausted": "U kunt uw mobiele nummer niet bijwerken omdat u het al MAX ({{maxLimit}}) keer heeft bijgewerkt. Neem contact op met de ondersteuning voor meer informatie!"
                },
                "button": {
                    "sendOTP": "Verstuur OTP",
                    "next": "Volgende",
                    "confirm": "Bevestigen",
                    "notGettingCode": "Ik ontvang de code niet"
                }
            },
            "message": {
                "success": "Mobiel nummer geverifieerd!",
                "errorValidatingOTP": "Fout bij het valideren van OTP!",
                "errorSendingOTP": "Er was een probleem met het verzenden van de OTP-code, probeer het later opnieuw!"
            },
            "modal": {
                "notGettingCode": {
                    "header": "Ik ontvang de code niet",
                    "body": {
                        "point1": "Het lijkt erop dat er momenteel een probleem is met het verzenden van een verificatiecode naar u. Probeer het later opnieuw",
                        "point2": "Voor hulp kunt u contact opnemen met onze ondersteuning via het Helpcentrum."
                    },
                    "button": {
                        "close": "Sluiten"
                    }
                }
            },
            "resendTimer": {
                "message": {
                    "secondsRemaining": "U kunt de OTP opnieuw aanvragen over <strong>{{secondsRemaining}}</strong> seconden"
                }
            }
        },
        "stepFive": {
            "title": "Identiteitsverificatie",
            "form": {
                "label": {
                    "identityVerificationDescription": "Klik op de onderstaande link om Identiteitsverificatie te starten.",
                    "identityVerificationResults": "Resultaten Identiteitsverificatie"
                },
                "button": {
                    "loading": "Laden...",
                    "verifyIdentity": "Verifieer Identiteit"
                },
                "table": {
                    "column": {
                        "type": "Type",
                        "status": "Status",
                        "details": "Details"
                    },
                    "label": {
                        "selfieVerification": "Selfie Verificatie",
                        "documentVerification": "Document Verificatie",
                        "verified": "Geverifieerd",
                        "notVerified": "Niet Geverifieerd",
                        "notAvailable": "N/B"
                    }
                },
                "message": {
                    "identityVerificationSuccess": "Uw identiteitsinformatie is geverifieerd, ons team zal de identiteitsinformatie beoordelen en binnen 2-3 werkdagen de definitieve goedkeuring geven.",
                    "identityVerificationFailed": "Uw identiteitsinformatie kon niet worden geverifieerd, dien de informatie opnieuw in! U heeft nog slechts <strong>{{attemptsRemaining}}</strong> poging over om uw identiteit te verifiëren.",
                    "identityVerificationMaxAttempts": "U heeft het maximale aantal pogingen voor Identiteitsverificatie bereikt, neem contact op met de ondersteuning voor meer informatie."
                }
            }
        },
        "stepSix": {
            "title": "Onderteken Contract",
            "form": {
                "label": {
                    "signContract": "Onderteken Contract"
                }
            }
        },
        "stepSeven": {
            "title": "Goedkeuring",
            "form": {
                "message": {
                    "approval": "Ons team zal alle door u verstrekte informatie beoordelen en binnen 3 werkdagen de definitieve goedkeuring geven."
                }
            }
        }
    },
    "signRedirectPages": {
        "signSuccess": {
            "title": "Contract Ondertekening Succesvol :)",
            "description": "U heeft uw contract succesvol ondertekend, de status wordt binnenkort in uw account bijgewerkt, vernieuw de pagina over enkele seconden."
        },
        "signLater": {
            "title": "Contract Later Ondertekenen ...",
            "description": "U heeft ervoor gekozen om het contract later te ondertekenen, voltooi deze stap zo snel mogelijk om distributie te verkrijgen."
        },
        "signDeclined": {
            "title": "Contract Ondertekening Geweigerd :(",
            "description": "U heeft geweigerd het contract te ondertekenen, dit zal het proces om distributie mogelijk te maken vertragen."
        },
        "signCompleted": {
            "title": "Contract Ondertekening Voltooid :)",
            "description": "Uw contract is afgerond, de status wordt binnenkort in uw account bijgewerkt, vernieuw de pagina over enkele seconden."
        }
    }
};

export default userDataFormNL;